import Store from '~/glm/models/store';
import { observable } from 'mobx';

export default class GuestWedding extends Store {
  @observable createdAt;
  @observable id;
  @observable isPrivateRsvp;
  @observable rsvpDeadline;
  @observable sendRsvpReminder;
  @observable updatedAt;
  @observable usesSubEvents;
  @observable usesQuestions;
  @observable questions;
  @observable allowGuestPreview;
}
